// extracted by mini-css-extract-plugin
export default {"cancel":"DeletePopUpContent_cancel__sHGUE","delete":"DeletePopUpContent_delete__qGOks","buttons":"DeletePopUpContent_buttons__tGwSN"};